import { CommonUtilities } from '../../commonUtils';

export default class TransactionServices {

    static MatchingCatalogue_TableConfig = [
        {
            tableHeader: ["Catalog", "Barcodenum", "Artist", "Title", "Format", "Label"],
            tableFields: ["catLogNumber", "barcodeNum", "artistName", "title", "format", "label"],
            tableType: "Releases"
        },
        {
            tableHeader: ["Track(s)/Song(s) ISRC", "Track(s)/Song(s) Artist	", "Title", "Title Version"],
            tableFields: ["intStdRecCode", "isrcArtistName", "trackTitle", "titleVersion"],
            tableType: "Track_Song"
        },
        {
            tableHeader: ["Contract Artist", "contractRefNum", "Contract Title", "Kontact Display"],
            tableFields: ["contractArtist", "contractRefNum", "contractTitle", "kontactDisplay"],
            tableType: "Contract"
        },
        {
            tableHeader: ["	ISRC", "Class List"],
            tableFields: ["releaseISRC", "classList",],
            tableType: "Class_List"
        }

    ];

    static MatchingSong_TableConfig = [
        {
            tableHeader: ["Catalog", "Barcodenum", "Artist", "Title", "Format", "Label"],
            tableFields: ["catLogNumber", "barcodeNum", "artistName", "title", "format", "label"],
            tableType: "Releases"
        },
        {
            tableHeader: ["Track(s)/Song(s) ISRC", "Track(s)/Song(s) Artist	", "Title", "Title Version"],
            tableFields: ["intStdRecCode", "isrcArtistName", "trackTitle", "titleVersion"],
            tableType: "Track_Song"
        },
        {
            tableHeader: ["Contract Artist", "contractRefNum", "Contract Title", "Kontact Display"],
            tableFields: ["contractArtist", "contractRefNum", "contractTitle", "kontactDisplay"],
            tableType: "Contract"
        },
        {
            tableHeader: ["	ISRC", "Class List"],
            tableFields: ["releaseISRC", "classList",],
            tableType: "Class_List"
        }

    ];

    static allHeaderType = [
        { "name": "Adjustments", "type": "Adjustments" },
        { "name": "Advances", "type": "Advances" },
        { "name": "Costs", "type": "Costs" },
        { "name": "Digital", "type": "Digital" },
        { "name": "Licensing", "type": "Licensing" },
        { "name": "Physical", "type": "Physical" },
        { "name": "Publishing - Song", "type": "PublishingSong" },
        { "name": "Publishing - Writer", "type": "PublishingWriter" }
    ];
    
    static tableConfig = [
        {
            tableHeader: [
                "Hold flag", "Invoice Ref", "Account Code", "Matched Item", "Territory Code", "Formats/Source Codes", "Analysis Code", "Units Sold", "Monetary Value",
                "Invoice Date", "Album Title", "Track Title", "Album Artist", "Track Artist"
            ],
            tableFields: [
                "holdFlag", "invoiceRef", "accountCode", "itemCodeSold", "mtchTerritoryCode", "mtchFormatCode", "mtchAnalysisCode", "analysisCode", "unitsSold",
                "monetaryValue", "invoiceDate", "albumTitle", "trackTitle", "albumArtist", "trackArtist"
            ],
            tableType: "1"
        },
        {
            tableHeader: [
                "Hold flag", "Invoice Ref", "Account Code", "Matched Item", "Territory Code", "Formats/Source Codes", "Analysis Code", "Units Sold", "Monetary Value",
                "Invoice Date", "Album Title", "Track Title", "Album Artist", "Track Artist"
            ],
            tableType: "2"
        }
    ];

    static projectStatement(param: any) {
        var url = 'contract/statement/project/list?' + CommonUtilities.buildQueryString(param, true, true)
        return CommonUtilities.getData(url);
    }

    static savePayment = function (period: any, type: any, postData: any, hold: any, payOpeningBalance: any) {
        if (!payOpeningBalance) {
            payOpeningBalance = false;
        }
        var url = 'contracts/savePayment/' + period + '?paymentType=' + type + '&hold=' + hold + '&payOpeningBalance=' + payOpeningBalance;

        console.log(postData)
        return CommonUtilities.postData(url, postData);
    };

    static history = function (param: any) {
        var url = 'salesAnalysis/invoices/costs?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    };

    static factSalesActListing = function (header: any, account: any, transId: any, param: any) {
        var url = 'salesAnalysis/factSalesAct/' + header + '/' + account + '/' + transId + '/1/0?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    };

    static getItemCodeSoldTracks(param: any) {
        var url = 'salesAnalysis/factSalesAct/getItemCodeSoldTracks?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    //getItemCodeSoldContracts
    static getItemCodeSoldContracts(param: any) {
        var url = 'salesAnalysis/factSalesAct/getItemCodeSoldContracts?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    //getItemCodeSoldCompilations
    static getItemCodeSoldCompilations(param: any) {
        var url = 'salesAnalysis/factSalesAct/getItemCodeSoldCompilations?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static subDetails(param: any) {
        var url = 'salesAnalysis/factSalesAct/' + param.headerType + '/' + param.accountCode + '/' + param.transactionRef + '/1/1';
        return CommonUtilities.getData(url);
    }

    static deleteFactSalesAct(param: any) {
        var url = 'salesAnalysis/deleteFactSalesAct';
        return CommonUtilities.postData(url, param);
    }

    static saveDetails(param: any) {
        var url = 'salesAnalysis/factSalesAct';
        return CommonUtilities.postData(url, param);
    }

    static invoice_save(param: any) {
        var url = 'salesAnalysis/invoice';
        return CommonUtilities.postData(url, param);
    }

    static salesAnalysisUpload(file: any) {
        var url = 'salesAnalysis/fileUpload'
        return CommonUtilities.postUploadFile(url, file, {});
    }

    static getTransactionRef(param: any) {
        var url = 'salesAnalysis/invoices/getTransactionRef?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }


    static ReCalcOpeningBalance(param: any) {
        var url = 'contracts/savePaymentKontactInfo?';
        return CommonUtilities.postData(url, param);
    }

    static savePaymentKontactInfo(param: any) {
        var url = 'contracts/ReCalcOpeningBalance';
        return CommonUtilities.postData(url, param);
    }

    static saveStatusFlag(param: any) {
        var url = 'contracts/saveStatusFlag/20240331/' + param?.status + '/2025';
        return CommonUtilities.postData(url, param);
    }

    static getPaymentDetails(period: any, param: any) {
        var url = 'contracts/getPaymentDetails/' + period + '?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static suggestedPayments(param: any) {
        var url = 'contracts/suggestedPayments/count?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static salesAnalysisExport(data: any) {
        const url = 'salesAnalysis/invoices/exportExcel?' + CommonUtilities.buildQueryString(data, true, false);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', 'Invoice Details_Excel');
    };

    static getViewAll(param: any, tabName: any, url_LINK: any) {
        var url = 'salesAnalysis/invoices/' + tabName + url_LINK + '?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static getInvoiceCheckDetails(param: any) {
        var url = 'salesAnalysis/invoices/checkReport/level1?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static viewAllDetils(param: any) {
        var url = 'salesAnalysis/invoices/digital/' + param.accountCode + '/' + param.invoiceNum + '/' + param.transactionRef + '/' + param.homeValue + '/' + param.currencySign + '/' + param.currencyValue + '/' + param.exchRate + '/' + param.royaltyPeriod + '/' + param.invoiceDate;
        return CommonUtilities.getData(url);
    }

    static matchingSearch(param: any) {
        var url = 'salesAnalysis/digital/20231231/searchRaw?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }



    // Transactions
    static searchRawInfo(headtype: any, period: any, param: any) {
        var url = 'salesAnalysis/' + headtype + '/' + period + '/searchRawInfo?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static searchRaw(headtype: any, period: any, param: any) {
        var url = 'salesAnalysis/' + headtype + '/' + period + '/searchRaw?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static searchActInfo(headtype: any, period: any, param: any) {
        var url = 'salesAnalysis/' + headtype + '/' + period + '/searchActInfo?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static searchAct(headtype: any, period: any, param: any) {
        var url = 'salesAnalysis/' + headtype + '/' + period + '/searchAct?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static searchRoyaltyInfo(headtype: any, period: any, param: any) {
        var url = 'salesAnalysis/' + headtype + '/' + period + '/searchRoyaltyInfo?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static searchRoyalty(headtype: any, period: any, param: any) {
        var url = 'salesAnalysis/' + headtype + '/' + period + '/searchRoyalty?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static searchRoyaltyDetail(headtype: any, period: any, param: any) {
        var url = 'salesAnalysis/' + headtype + '/' + period + '/searchRoyaltyDetail?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static searchMechanicalInfo(headtype: any, period: any, param: any) {
        var url = 'salesAnalysis/' + headtype + '/' + period + '/searchMechanicalInfo?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static searchMechanical(headtype: any, period: any, param: any) {
        var url = 'salesAnalysis/' + headtype + '/' + period + '/searchMechanical?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static searchMechanicalDetail(headtype: any, period: any, param: any) {
        var url = 'salesAnalysis/' + headtype + '/' + period + '/searchMechanicalDetail?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    // Publishing - Song Arena
    static Raw(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }

    static Audit(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static Publishing(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }

    //iTunes Monthly - File History Button
    static fileHistory(param: any) {
        var url = 'itunes/getFileHistory/count?'
        return CommonUtilities.getData(url);
    }


    //Youtube Reports
    static youtubeV1Reports(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static youtubeV1_1Reports(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static youtubeV1PublisherReports(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static youtubeV1PublisherAdjReports(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }

    //Youtube Red Reports
    static youtubeRedV1Reports(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static youtubeRedV1_1Reports(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }

    // Google Play
    static googlePlayManual(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }
    static googlePlayAuto(Data: {}) {
        var url = '' + Data;
        return CommonUtilities.getData(url);
    }


    // Matching Territories
    static periodCount(param: any) {
        var url = 'common/periodCount?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url)
    }

    static territoryCode(param: any) {
        var url = 'contracts/territoryCode/' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static contractsanalysisCodes() {
        var url = 'contracts/analysisCodes/';
        return CommonUtilities.getData(url);
    }

    static contractssystemFormats(Contact: any) {
        var url = 'contracts/systemFormats?' + CommonUtilities.buildQueryString(Contact, true, true);
        return CommonUtilities.getData(url);
    }

    static getTerritoryCode(param: any) {
        var url = 'salesAnalysis/getTerritoryAliases/' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static deleteTerritoryAliases(param: any) {
        var url = 'salesAnalysis/deleteTerritoryAliases'
        return CommonUtilities.postData(url, param);
    }

    static deleteFormatAlias(param: any) {
        var url = 'salesAnalysis/deleteFormatAlias'
        return CommonUtilities.postData(url, param);
    }

    static saveFormatAlias(account: any, param: any) {
        var url = 'salesAnalysis/saveFormatAlias/' + account
        return CommonUtilities.postData(url, param);
    }

    static saveTerritoryAliases(param: any) {
        var url = 'salesAnalysis/saveTerritoryAliases'
        return CommonUtilities.postData(url, param);
    }

    static getTerritoryAliasesExport(param: any) {
        var url = 'salesAnalysis/getTerritoryAliases/export'
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', 'Invoice Details_Excel');
    }

    static getCodingStr(param: any) {
        var url = 'salesAnalysis/getCodingStr/' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static getFactSalesRawAccountCode(param: any) {
        var url = 'salesAnalysis/getFactSalesRawAccountCode/0' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static matchingCalatog(param: any) {
        var url = 'salesAnalysis/getFactSalesRawAccountCode/1' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static matchingSongs(param: any) {
        var url = 'salesAnalysis/getFactSalesRawAccountCode/2' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static getFactSalesRawSubInfoByAccountCode(param: any) {
        var url = 'salesAnalysis/getFactSalesRawSubInfoByAccountCode/' + param;
        return CommonUtilities.getData(url);
    }

    static getFactSalesRawSubInfoByAccountCodeExport(type: any) {
        var url = 'salesAnalysis/getFactSalesRawSubInfoByAccountCode/' + type + '/export';
        return CommonUtilities.getData(url);
    }

    static getRelAliases(param: any) {
        var url = 'salesAnalysis/getRelAliases?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static saveRelAliases = function (accountCode: any, isGen: any, postData: any) {
        var url = 'salesAnalysis/' + accountCode + '/saveRelAliases/' + isGen;
        return CommonUtilities.postData(url, postData);
    };

    static saveRelAliasesPub = function (accountCode: any, isGen: any, postData: any) {
        var url = 'salesAnalysis/' + accountCode + '/saveRelAliasesPub/' + isGen;
        return CommonUtilities.postData(url, postData);
    };

    static getRelAliasesCount(param: any) {
        var url = 'salesAnalysis/getRelAliasesCount?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static getFormatAlias(param: any) {
        var url = 'salesAnalysis/getFormatAlias/' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static checkUploadYoutube(param: any) {
        var url = 'dataManagement/youtube/checkUpload?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static checkUploadYoutubeRed(param: any) {
        var url = 'dataManagement/youtube/checkUpload?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static viewYTUploadFileLog(param: any) {
        var url = 'importLog/SearchFileLog/YT/none?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static viewYRUploadFileLog(param: any) {
        var url = 'importLog/SearchFileLog/YR/none?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static viewAZUploadFileLog(param: any) {
        var url = 'importLog/SearchFileLog/AZ/none?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static viewGPUploadFileLog(param: any) {
        var url = 'importLog/SearchFileLog/GP/none?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }
    static viewSPUploadFileLog(param: any) {
        var url = 'importLog/SearchFileLog/SP/none?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static getSpotifyExchangeRate(param: any) {
        var url = 'dataManagement/spotify/getSpotifyExchangeRate/' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static customTransactionSummary(invoiceNum: any) {
        var url = 'salesAnalysis/invoices/' + invoiceNum + '/customTransactionSummary'// + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static checkImportLogFile(invoiceNum: any) {
        var url = 'importLog/checkImportLogFile/' + invoiceNum
        return CommonUtilities.getData(url);
    }

    static getFactSalesRawCount(param: any) {
        var url = 'salesAnalysis/factSalesRaw/getFactSalesRawCount?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static impHolStreamDetailData(param: any) {
        var url = 'salesAnalysis/impHolStream/detailData?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static getMetadataMain(param: any) {
        var url = 'salesAnalysis/factSalesAct/getMetadataMain?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static searchImportLog(invoice: any, param: any) {
        var url = 'importLog/searchImportLog/' + invoice + '?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static deleteImportLog(param: any) {
        var url = 'importLog/deleteImportLog'
        return CommonUtilities.postData(url, param);
    }

    static reUploadFile(fileName: any, invoiceId: any, kontactCode: any, invoiceRef: any, multipleFile: any) {
        var url = 'salesAnalysis/reUploadFile/' + fileName + '/' + invoiceId + '/' + kontactCode.trim() + '/' + invoiceRef + '/' + multipleFile;
        return CommonUtilities.getData(url);
    }

    static loadfactSalesActsCAA = function (headerType: any, invoiceDate: any, invoiceDate2: any, accountCode: any, invoiceRef: any, quickEntry: any, newRecord: any, pageNumber: any, pageSize: any, searchFor: any) {
        var url = 'salesAnalysis/factSalesAct/' + headerType + '/' + accountCode + '/' + invoiceRef + '/' + quickEntry + '/' + newRecord;
        return CommonUtilities.getData(url);
    }

    static updateField = function (fieldName: any, condition: any, value: any, invRef: any) {
        var url = 'salesAnalysis/uploadField/' + fieldName + '/' + condition + '/' + value + '/' + invRef;
        return CommonUtilities.getData(url);
    };

    static customPostSales = function (postSales: any) {
        var url = 'contracts/saleAnalysisListing?' + CommonUtilities.buildQueryString(postSales, true, true);
        return CommonUtilities.getData(url);
    };

    static recycleInvoice = function (invRef: any) {
        var url = 'salesAnalysis/recycleInvoice/' + invRef;
        return CommonUtilities.getData(url);
    };

    static delInvoiceFileIng = function (invRef: any, invType: any) {
        var url = 'salesAnalysis/delInvoiceFileIng/' + invRef + '/' + invType;
        return CommonUtilities.getData(url);
    };

    static deleteInvoice = function (invoice: any) {
        var url = 'salesAnalysis/deleteInvoices';
        return CommonUtilities.postData(url, invoice);
    };

    static approveAll = function (type: any) {
        var url = 'salesAnalysis/approveAll/' + type;
        return CommonUtilities.getData(url);
    };

    /*************Matching*************/
    static updateAndCommitSystem = function () {
        var url = 'salesAnalysis/updateAndCommitSystem';
        return CommonUtilities.postData(url, {});
    };

    static invoicePostApproved = function (royaltyPeriod: any, isMech: any) {
        var url = 'salesAnalysis/postApprovalInvoices/' + royaltyPeriod + '/' + isMech;
        return CommonUtilities.postData(url, { 'periodNum': royaltyPeriod, 'isMech': isMech });
    };

    static isrcmapping = function (param: any) {
        var url = 'salesAnalysis/isrcmapping/all?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    };

    static getUnmatchedTerritories = function (param: any) {
        var url = 'salesAnalysis/getUnmatchedTerritories'
        return CommonUtilities.getData(url);
    };

    static getUnmatchedTerritoriesExport = function (param: any) {
        var url = 'salesAnalysis/getUnmatchedTerritories/export'
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', 'Invoice Details_Excel');
    };

    static getUnmatchedCatalogue = function (accountCode: any, param: any) {
        var url = 'salesAnalysis/' + accountCode + '/catalogue/unmatched?' + CommonUtilities.buildQueryString(param, true, false);
        return CommonUtilities.getData(url);
    };

    static getUnmatchedSong = function (accountCode: any, param: any) {
        var url = 'salesAnalysis/' + accountCode + '/song/unmatched?' + CommonUtilities.buildQueryString(param, true, false);
        return CommonUtilities.getData(url);
    };

    static getUnmatchedCatalogueExport = function (accountCode: any, param: any) {
        var url = 'salesAnalysis/' + accountCode + '/catalogue/unmatched/export?' + CommonUtilities.buildQueryString(param, true, false);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', 'unmatched');
    };

    static getUnmatchedSongExport = function (accountCode: any, param: any) {
        var url = 'salesAnalysis/' + accountCode + '/song/unmatched/export?' + CommonUtilities.buildQueryString(param, true, false);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', 'unmatched');
    };

    static trackMatchingCatalogueSearch = function (param: any) {
        var url = 'salesAnalysis/trackMatchingCatalogueSearch?' + CommonUtilities.buildQueryString(param, true, false);
        return CommonUtilities.getData(url);
    };

    static contractMatchingCatalogueSearch = function (param: any) {
        var url = 'salesAnalysis/contractMatchingCatalogueSearch?' + CommonUtilities.buildQueryString(param, true, false);
        return CommonUtilities.getData(url);
    };

    static releaseMatchingCatalogueSearch = function (param: any) {
        var url = 'salesAnalysis/releaseMatchingCatalogueSearch?' + CommonUtilities.buildQueryString(param, true, false);
        return CommonUtilities.getData(url);
    };

    static classListMatchingCatalogueSearch = function (param: any) {
        var url = 'salesAnalysis/classListMatchingCatalogueSearch?' + CommonUtilities.buildQueryString(param, true, false);
        return CommonUtilities.getData(url);
    };



    static isrcmappingSave = function (param: any) {
        var url = 'salesAnalysis/isrcmapping'
        return CommonUtilities.postData(url, param);
    };

    static isrcmappingfactsalesdata = function (param: any) {
        var url = 'salesAnalysis/isrcmapping/factsalesdata'
        return CommonUtilities.putData(url, param);
    };

    static isrcmappingDelete = function (isrcmappingID: any) {
        var url = 'salesAnalysis/isrcmapping/' + isrcmappingID
        return CommonUtilities.deleteData(url);
    };

    static searchRawExport(headerType: any, data: any) {
        const url = 'salesAnalysis/' + headerType + '/searchRaw/export?' + CommonUtilities.buildQueryString(data, true, false);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', 'Invoice Details_Excel');
    };

    static searchActExport(headerType: any, data: any) {
        const url = 'salesAnalysis/' + headerType + '/searchAct/export?' + CommonUtilities.buildQueryString(data, true, false);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', 'Invoice Details_Excel');
    };

    static searchSalesAnalysisSummaryExport(headtype: any, period: any, areaType: any, param: any) {
        const url = 'salesAnalysis/' + headtype + '/' + period + '/' + areaType + '/excelSummaryExport?' + CommonUtilities.buildQueryString(param, true, false);
        return CommonUtilities.exportVsWindow(url);
    }

    static searchSalesAnalysisAllExport(headtype: any, period: any, areaType: any, param: any) {
        const url = 'salesAnalysis/' + headtype + '/' + period + '/' + areaType + '/excelExport?' + CommonUtilities.buildQueryString(param, true, false);
        return CommonUtilities.exportVsWindow(url);
    }

    static deleteRelAliases(aliasID: any) {
        const url = 'salesAnalysis/CLASS/deleteRelAliases/' + aliasID;
        return CommonUtilities.deleteData(url)
    };

    static deleteRelAliasesPub(aliasID: any) {
        const url = 'salesAnalysis/CLASS/deleteRelAliasesPub/' + aliasID;
        return CommonUtilities.deleteData(url);
    };

}